import PageFlow from '../../components/PageFlow'
import RegisterMFACompleteStep from '../../components/RegisterMFACompleteStep'
import { RegisterStep, StartRegistrationStep } from './steps'
import {
  REGISTER,
  REGISTRATION_COMPLETE,
  START_REGISTRATION,
} from '../../constants/mfa.setup.steps'

const DEFAULT_LOCATION = { state: { isFromSettings: false } }

const SetupMFATOTP = ({
  location = DEFAULT_LOCATION,
  step,
  rootPath,
  settingsPath,
  onComplete,
  ...rest
}) => {
  const { isFromSettings } = location.state || {}
  const stepProps = { ...rest, location, step }

  return (
    <PageFlow currentStep={step}>
      <PageFlow.Step name={START_REGISTRATION}>
        <StartRegistrationStep {...stepProps} />
      </PageFlow.Step>
      <PageFlow.Step name={REGISTER}>
        <RegisterStep {...stepProps} />
      </PageFlow.Step>
      <PageFlow.Step name={REGISTRATION_COMPLETE}>
        <RegisterMFACompleteStep
          isFromSettings={isFromSettings}
          rootPath={rootPath}
          settingsPath={settingsPath}
          onComplete={onComplete}
        />
      </PageFlow.Step>
    </PageFlow>
  )
}

export default SetupMFATOTP
